import { IQueryMediator } from 'core-ts-types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';
import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';

function deletePreviewTimesCommandDefinition(
  defineCommand: any,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
  QueryMediator: IQueryMediator
): any {
  return defineCommand(
    'deletePreviewTimesCommand',
    function deletePreviewTimesCommand(deferred: ng.IDeferred<any>): any {
      _.remove(ngTimeOccurrenceDataSource.store, (timeBlock: ITimeOccurrenceDatatype) => timeBlock.isPreview);
      QueryMediator.runQueries(ngTimeOccurrenceDataSource);
      deferred.resolve();
    }
  );
}

angular.module('ui-ng-calendar').factory('deletePreviewTimesCommand', deletePreviewTimesCommandDefinition);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/delete_preview_times.ts